<div class="bg-[#D8D6D6] flex h-[43px] justify-between"  style=" box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);">
    <p  class="!text-[18px] !text-[#343A40] font-semibold p-2 !pl-[10px]">{{data.header}}</p>
    <!-- <button class="!float-right rounded-full no-border" mat-dialog-close>
      <mat-icon class="!border-none !overflow-hidden">close</mat-icon>
    </button> -->
  </div>
  <mat-dialog-content class="mat-mdc-dialog-surface mdc-dialog__surface relative !pb-16">
    <p class="!!font-roboto text-[15px] font-normal !text-black " style="padding: 2rem 5px 2rem 10px;">{{data.message}}</p>
    <!-- <p class="p-3">Are you sure this approach will prevent companies from submitting their EOI responses?</p> -->
    <!-- Buttons container -->
    <div 
      class="!w-[100%] flex justify-end items-center absolute bottom-0 left-0 p-4 bg-white"
    >
      <button
        type="button"
        class="back-btn !w-[85px] !h-[39px] flex justify-center items-center border border-[#E76B3F] bg-[#F1F3F5] !text-[#E76B3F]  !text-[16px] !rounded-[3px] mr-2" style=" box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);"
        (click)="onClose()"
        >
        No
      </button>
      <button
        class="!w-[85px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px] " style=" box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);"
      (click)="onConfirm()"
        >
        Yes
      </button>
    </div>
  </mat-dialog-content>